__turbopack_context__.v({
  "caret": "J4UU2a_caret",
  "root": "J4UU2a_root",
});
